module.exports = __webpack_public_path__ + "media/images/games/k2gender/mechanic-c13084841c58351c812442c30fea1585.png";